<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn 
                icon 
                dark 
                :disabled="submitLoading" 
                @click="cancel">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span v-if="editing">Edit Classification</span>
                <span v-else>Add New Classification</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="editForm" v-model="editValid">
            <v-layout class="dialog-content">
                <v-flex xs12 md6 offset-md3 mt-4>
                    <v-layout wrap>                        
                        <v-flex xs12>
                            <v-text-field 
                                box
                                clearable
                                label="Name"
                                v-model="editData.Name" 
                                :rules="[
                                    rules.required, 
                                    rules.maxOneHundredCharacters
                                ]" 
                                counter >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox 
                                label="Active"
                                v-model="editData.IsActive">
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>
                                    <span>Classification Types</span>                                    
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon color="accent" @click="addEditClassificationType({ IsActive: true })">
                                    <v-icon large>add</v-icon>
                                </v-btn>
                            </v-toolbar>
                        </v-flex>
                        <v-flex xs12>
                            <pest-classification-type-table :items="editData.ClassificationTypes" @edit="addEditClassificationType($event)" ></pest-classification-type-table>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="success" 
                                :disabled="!editValid" 
                                :loading="submitLoading" 
                                @click="submit">
                                <span>Save</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="error" 
                                :disabled="submitLoading" 
                                @click="cancel">
                                <span>Cancel</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-alert 
                                :value="submitError != null" 
                                outline 
                                type="error">
                                <span>{{ submitError }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
        <v-dialog 
            :value="showEditClassificationType"
            max-width="500px" 
            persistent
            >
            <pest-classification-type-edit 
                v-if="showEditClassificationType"
                :item="classificationTypeEditData"
                :submitError="error"
                @submit="handleClassificationTypeSubmit"
                @cancel="handleClassificationTypeCancel">
            </pest-classification-type-edit>
        </v-dialog>
    </v-card>    
</template>

<script>
import PestClassificationTypeTable from "@/components/configuration/pestClassifications/PestClassificationTypeTable.vue";
import PestClassificationTypeEdit from "@/components/configuration/pestClassifications/PestClassificationTypeEdit.vue";

import validationRules from "@/helpers/validationrules";

export default {
    components: {
        PestClassificationTypeTable: PestClassificationTypeTable,
        PestClassificationTypeEdit: PestClassificationTypeEdit
    },
    props: {
        item: {
            required: true,
            type: Object
        },
        submitError: {
            required: false,
            type: String
        },
        submitLoading: {
            required: false,
            type: Boolean
        }
    },
    data(){
        return {
            rules: validationRules.rules,
            editData: {},
            editValid: false,
            showEditClassificationType: false,
            classificationTypeEditData: {},
            index: 0,
            error: null   
        }
    },
    computed: {
        editing(){
            return this.editData.PestClassificationID != null;
        }
    },
    methods: {
        cancel(){
            this.$emit("cancel");
        },
        submit(){
            this.$emit("submit", this.editData);
        },
        addEditClassificationType(item) {
            item.index = this.index;
            this.index += 1;

            this.classificationTypeEditData = item;
            this.showEditClassificationType = true;
        },
        handleClassificationTypeCancel() {
            this.showEditClassificationType = false;
            this.error = null;            
        },
        handleClassificationTypeSubmit(item) {
            if (this.editData.ClassificationTypes.filter(a => a.Name.trim() === item.Name.trim() && a.index !== item.index).length > 0) {
                this.error = "Classification Type with the same name already exists."
                return;
            }
            
            this.error = null;
            this.showEditClassificationType = false;

            let index = this.editData.ClassificationTypes.findIndex(a => a.index === item.index);            

            if (index >= 0) {
                this.editData.ClassificationTypes.splice(index, 1, item);
            } else {
                this.editData.ClassificationTypes.push(item);
            }
        }
    },
    async created() {
        this.editData = JSON.parse(JSON.stringify(this.item));
    }
}
</script>